'use client';

import { IconChevronDownFilled } from '@zillow/constellation-icons/react/filled/icon-chevron-down-filled';
import { forwardRef, useContext } from 'react';

import { css, cx } from '@/styled-system/css';

import { expandIconRecipe } from '../../styles/expand-icon.styles';
import { Button } from '../button';
import { MenuRootContext } from './context/menu-root.context';
import type { MenuButtonPropsInterface } from './types/menu-button.types';

export const MenuButton = forwardRef<HTMLButtonElement, MenuButtonPropsInterface>(
  (props: MenuButtonPropsInterface, forwardedRef) => {
    const { children, css: cssProp, ...rest } = props;
    const { menu } = useContext(MenuRootContext);

    const iconStyles = css(expandIconRecipe.raw({ open: menu.open }));

    return (
      <Button.Root
        ref={forwardedRef}
        data-c11n-version={__C11N_VERSION__}
        data-c11n-component="Menu.Button"
        tone="brand"
        emphasis="outlined"
        css={cssProp}
        {...rest}
        className={cx('c11n_menu__button', rest.className)}
      >
        <Button.Label>{children}</Button.Label>
        <span className={cx('c11n', iconStyles)}>
          <Button.Icon render={<IconChevronDownFilled />} />
        </span>
      </Button.Root>
    );
  },
);

MenuButton.displayName = 'Menu.Button';
